import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

function getBreadcrumbs(pathname: string): BreadcrumbItem[] {
  const crumbs: BreadcrumbItem[] = [{ label: '首页', href: '/' }];
  const segments = pathname.split('/').filter(Boolean);

  if (segments[0] === 'category' && segments[1]) {
    const categoryNames: Record<string, string> = {
      dongzuo: '动作片',
      kehuan: '科幻片',
      xiju: '喜剧片',
      aiqing: '爱情片',
      kongbu: '恐怖片',
      donghua: '动画片',
      zhanzheng: '战争片',
      jilupian: '纪录片',
    };
    crumbs.push({ label: categoryNames[segments[1]] || segments[1], href: `/category/${segments[1]}` });
  } else if (segments[0] === 'movie' && segments[1]) {
    crumbs.push({ label: '电影详情', href: pathname });
  } else if (segments[0] === 'about') {
    crumbs.push({ label: '关于我们', href: '/about' });
  }

  return crumbs;
}

export default function Breadcrumb() {
  const location = useLocation();
  const breadcrumbs = getBreadcrumbs(location.pathname);

  if (breadcrumbs.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="px-4 md:px-6 py-3">
      <ol className="flex items-center gap-2 text-sm">
        {breadcrumbs.map((crumb, index) => (
          <li key={index} className="flex items-center gap-2">
            {index > 0 && (
              <span className="text-foreground-400">
                <i className="ri-arrow-right-s-line text-sm"></i>
              </span>
            )}
            {crumb.href && index < breadcrumbs.length - 1 ? (
              <Link to={crumb.href} className="text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                {crumb.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">{crumb.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}